/* sucrase/dist/esm/parser/index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    exports.parse = parse;
    const base_1 = require("540718e523") /* ./traverser/base */;
    const index_1 = require("5bde8156b9") /* ./traverser/index */;
    class File {
        constructor(tokens, scopes) {
            this.tokens = tokens;
            this.scopes = scopes;
        }
    }
    exports.File = File;
    function parse(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
        if (isFlowEnabled && isTypeScriptEnabled) {
            throw new Error("Cannot combine flow and typescript plugins.");
        }
        (0, base_1.initParser)(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
        const result = (0, index_1.parseFile)();
        if (base_1.state.error) {
            throw (0, base_1.augmentError)(base_1.state.error);
        }
        return result;
    }
}
